module.exports = __webpack_public_path__ + "static/media/chevron_light.cfea07da.svg";